var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.493 20.92l-.01-.038-5.259-13.364A1.81 1.81 0 0034.5 6.243H13.18c-.796 0-1.504.53-1.73 1.294L6.535 20.765l-.015.033-.009.038c-.06.23-.08.463-.047.693-.004.075-.01.15-.01.225v17.152a2.855 2.855 0 002.85 2.85h29.4c1.571 0 2.85-1.28 2.856-2.85V21.754c0-.06 0-.122-.005-.173.019-.23 0-.45-.061-.661zm-13.866-2.016l-.014.736c-.037 2.105-1.49 3.52-3.614 3.52-1.036 0-1.926-.332-2.569-.965-.642-.633-.993-1.514-1.012-2.555l-.014-.736h-9.647l3.727-9.06h18.712l3.83 9.06h-9.399zm-17.578 3.6h7.374c1.139 2.677 3.562 4.256 6.58 4.256 1.58 0 3.048-.44 4.234-1.275 1.04-.73 1.851-1.753 2.376-2.98h7.336v15.65h-27.9v-15.65z",
    fill: "#2F54EB"
  })));
}

export default __webpack_public_path__ + "./fonts/upload-icon.d92166b8b329ea9ce67fbb98b67960cb.svg";
export { SvgUploadIcon as ReactComponent };